import { Modal, ModalBody, ModalHeader } from '@americanexpress/dls-react';
import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  useCommonContent,
  useOneCmsLocalePartners,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useModal } from '@/context/modalContext';
import LoungeTermsContent from '../LoungeTermsContent';
import PartnerTermsContent from '../PartnerTermsContent';

export const TermsModal = () => {
  const { closeModal } = useModal();
  const { loungeId } = useRouteParams();
  const partners = useOneCmsLocalePartners();

  const {
    footer: { additionalInfo },
  } = useCommonContent();
  const termsContent = loungeId ? (
    <LoungeTermsContent loungeId={loungeId} partners={partners} />
  ) : (
    <PartnerTermsContent type="terms" partners={partners} />
  );
  return (
    <Modal
      id="terms-modal"
      onClose={closeModal}
      className="first-child_tw-items-end first-child_sm_tw-items-center"
      innerContainerClassName="tw-max-w-screen-sm md_tw-max-w-screen-md tw-m-0 sm_tw-m-4"
    >
      <ModalHeader id="terms-modal-header">
        <h3>{additionalInfo?.termsLabel}</h3>
      </ModalHeader>
      <ModalBody
        id="terms-modal-content"
        className="tw-min-h-75dvh tw-max-h-75vh-important sm_tw-min-h-full"
      >
        {termsContent}
      </ModalBody>
    </Modal>
  );
};
